import PageSpinner from "components/Spinners/PageSpinner";
import { useCompanyListQuery } from "hooks/useCompany";
import type React from "react";

// Mounts the shared company-list query once, near the top of the admin tree, and
// blocks the app behind a spinner until it resolves. This warms the TanStack
// cache so every descendant `useCompanies()` / `useSelectedCompany()` is a cache
// hit and a company is always resolvable before routes render.
//
// TODO: paginate or move to server-side search once company count approaches the
// max_items ceiling — the global selector fetches the full list once and filters
// client-side, so it silently truncates above max_items.
export default function CompanyListGate(props: {
  children: React.ReactNode;
}): React.ReactElement {
  const { data, isLoading } = useCompanyListQuery();

  return (
    <PageSpinner spin={isLoading}>
      {!isLoading && data && <>{props.children}</>}
    </PageSpinner>
  );
}
